import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Banner_1 from '../../../assets/images/home_page_3/banner/02.png'
import Banner_2 from '../../../assets/images/home_page_3/banner/03.png'
import Banner_3 from '../../../assets/images/home_page_3/banner/01.png'

const Banslider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    Speed: 3000,
    autoplay: true,
    autoplaySpeed: 1000
}

const   Banner = () => {
    return (
        <>
            <section id="home-three" className="home-three-main-block">
                <div className="container-fluid">
                    <div className="home-three-circle-one" />
                    <div className="home-three-circle-two" />
                    <div className="home-three-line-one" />
                    <div className="home-three-circle-three" />
                    <div className="home-three-circle-four" />
                    <div className="home-three-circle-five" />
                    <div className="home-three-bg-text-block">
                        <h1 className="home-three-bg-title">
                            Summer <br /> Sale
                        </h1>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <Slider className="slider home-three-nav-slider" {...Banslider}>
                                <div className="home-three-slider-dtl">
                                    <div className="section-sub-title">Summer Sales Is Fire</div>
                                    <h1 className="section-title-three">Discover Men’s Latest Collection</h1>
                                    <Link to="#" className="btn btn-primary-three" title="">
                                        Explore Now
                                    </Link>
                                </div>
                                <div className="home-three-slider-dtl">
                                    <div className="section-sub-title">Summer Sales Is Fire</div>
                                    <h1 className="section-title-three">Discover Men’s Latest Collection</h1>
                                    <Link to="#" className="btn btn-primary-three" title="">
                                        Explore Now
                                    </Link>
                                </div>
                            </Slider>
                        </div>
                        <div className="col-lg-6">
                            <Slider className="slider home-three-for-slider" {...Banslider}>
                                <div className="home-three-img-one-block">
                                    <img
                                        src={Banner_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="home-three-img-one-block">
                                    <img
                                        src={Banner_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <div className="home-three-bg-img" >
                        <img
                            src={Banner_3}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                </div>
            </section>

        </>
    )
}

export default Banner
